"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicH1 = void 0;
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DynamicH1 = function (_a) {
    var title = _a.title;
    return react_1.default.createElement("h1", { className: styles_module_scss_1.default.visuallyHidden }, title);
};
exports.DynamicH1 = DynamicH1;
